<form [formGroup]="form" class="container" fxLayout="column" fxLayoutGap="16px">

  <!-- Loading Overlay for Saving -->
  <div *ngIf="isSaving" class="saving-overlay">
    <div class="saving-content">
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
        <path
          d="M28 0H4C1.78 0 0 1.8 0 4V32C0 34.2 1.78 36 4 36H32C34.2 36 36 34.2 36 32V8L28 0ZM18 32C14.68 32 12 29.32 12 26C12 22.68 14.68 20 18 20C21.32 20 24 22.68 24 26C24 29.32 21.32 32 18 32ZM24 12H4V4H24V12Z"
          fill="url(#paint0_linear_2463_3)" />
        <defs>
          <linearGradient id="paint0_linear_2463_3" x1="1.37872" y1="2.02817" x2="37.5793" y2="17.9153"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#B9AB1C" />
            <stop offset="1" stop-color="#8E8501" />
          </linearGradient>
        </defs>
      </svg>
      <div style="min-height: 28px;"></div>
      <label class="dialogHeader">Saving captured meter reading. Please wait while processing.</label>
      <label class="dialogSubheader"></label>

      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>

  <!-- Success Message -->
  <div *ngIf="showSuccessMessage" class="message-overlay success-overlay">
    <div class="saving-content">
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
        <path
          d="M28 0H4C1.78 0 0 1.8 0 4V32C0 34.2 1.78 36 4 36H32C34.2 36 36 34.2 36 32V8L28 0ZM18 32C14.68 32 12 29.32 12 26C12 22.68 14.68 20 18 20C21.32 20 24 22.68 24 26C24 29.32 21.32 32 18 32ZM24 12H4V4H24V12Z"
          fill="url(#paint0_linear_2463_3)" />
        <defs>
          <linearGradient id="paint0_linear_2463_3" x1="1.37872" y1="2.02817" x2="37.5793" y2="17.9153"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#B9AB1C" />
            <stop offset="1" stop-color="#8E8501" />
          </linearGradient>
        </defs>
      </svg>
      <div style="min-height: 28px;"></div>
      <label class="dialogHeader">Meter reading saved successfully.</label>
      <label class="dialogSubheader"></label>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="showErrorMessage" class="message-overlay error-overlay">
    <div class="message-content">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path
          d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM22 30H18V18H22V30ZM22 14H18V10H22V14Z"
          fill="url(#paint0_linear_2463_23)" />
        <defs>
          <linearGradient id="paint0_linear_2463_23" x1="1.53191" y1="2.25352" x2="41.7548" y2="19.9058"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#B9AB1C" />
            <stop offset="1" stop-color="#8E8501" />
          </linearGradient>
        </defs>
      </svg>
      <div style="min-height: 28px;"></div>
      <label class="dialogHeader">{{ errorMessage }}</label>
      <label class="dialogSubheader">{{ subMessage }}</label>
      <div class="devider"></div>
      <div class="error-buttons" style="width: 100%;">
        @if(subMessage === 'Please Capture Reading value.' ||
        subMessage === 'You have not captured any image/s. Do you want to continue without them?'){
        <button mat-button style="width: 100%;" (click)="closeErrorMessage()">CANCEL </button>
        }
        @else if(subMessage === 'Meter reading saved to device in offline mode. Please sync when back online') {
        <button type="button" mat-button (click)="closeErrorMessageCancel($event)">Back To List</button>
        }
        @else {
        <button mat-flat-button style="width: 100%;" (click)="closeErrorMessage()">Ok</button>
        }
        @if(subMessage === 'You have not captured any image/s. Do you want to continue without them?'){
        <button mat-flat-button color="warn" style="width: 100%;" (click)="onSubmit('yes')">Continue</button>
        }
      </div>
    </div>
  </div>

  <!-- Main Form Content -->
  <div class="form-content" [class.blur-background]="isSaving || showSuccessMessage || showErrorMessage">

    <!-- Info Card -->

    <mat-card style="padding: 8px;margin-top: 70px;">
      <!-- <div>
        <app-meter-ocr></app-meter-ocr>
        <h2>Upload Meter Image</h2>
        <input type="file" (change)="onFileSelected($event)" accept="image/*" />
        <div *ngIf="imageUrl">
          <img [src]="imageUrl" alt="Uploaded Meter" style="max-width: 100%; margin-top: 1rem;" />
        </div>
              
        <div *ngIf="resultText">
          <h3>Extracted Text:</h3>
          <pre>{{ resultText }}</pre>
        </div>
      </div> -->
      <mat-card-title>{{ form.value.tradingName }}</mat-card-title>
      <mat-card-subtitle>
        Meter #: <strong>{{ form.value.meterNumber }}</strong><br />
        Type : <strong>{{ form.value.utilityType }} </strong>
      </mat-card-subtitle>
      <div style="min-height: 16px"></div>
      <div class="period-closed-card" *ngIf="!allowCapture">
        <div class="card-content">

          <div class="status-text">
            <span>
              <!-- SVG -->
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_2534_2139)">
                  <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="#C8AE1D" />
                </g>
                <defs>
                  <clipPath id="clip0_2534_2139">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>

            Period Reading is currently closed and cannot be submitted for this date range.
          </div>

        </div>
      </div>

      <mat-form-field class="custom-mdc-form-field" appearance="outline" style="margin-top: 16px;">

        <mat-label>Reading Type</mat-label>
        <mat-select formControlName="captureType">
          <mat-option *ngFor="let type of readingTypes" [value]="type.name">
            {{ type.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-card>

    <!-- Reading Section -->

    <form [formGroup]="imageForm" style="margin-top: 16px;">
      <mat-accordion multi="false">
        <ng-container *ngFor="let image of images; let i = index">
          <mat-expansion-panel *ngIf="i < numberOfImages" [expanded]="i === 0">
            <!-- HEADER -->
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ image.label }}
              </mat-panel-title>
              <mat-panel-description>
                <span *ngIf="imageForm.get(image.formControl)?.value">
                  {{ imageForm.get(image.formControl)?.value }}
                </span>

              </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- PREVIEW IMAGE -->
            <div *ngIf="image.base64" class="image" style="margin-bottom: 14px;">
              <img [src]="image.base64" alt="Captured"
                style="width: 100%; border-radius: 4px; height: 120px; object-fit: contain;" />
            </div>

            <!-- INPUT + CAPTURE BUTTON -->
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6">
              <mat-form-field appearance="outline" style="width: 80%;">
                <mat-label>{{ image.label }}</mat-label>
                <input type="number" matInput [placeholder]="image.placeholder" [formControlName]="image.formControl" />
              </mat-form-field>

              <button mat-icon-button (click)="triggerImageCapture(fileInputs.get(i))">
                <mat-icon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M21.5 6.5H18.33L16.5 4.5H10.5V6.5H15.62L17.45 8.5H21.5V20.5H5.5V11.5H3.5V20.5C3.5 21.6 4.4 22.5 5.5 22.5H21.5C22.6 22.5 23.5 21.6 23.5 20.5V8.5C23.5 7.4 22.6 6.5 21.5 6.5ZM8.5 14.5C8.5 17.26 10.74 19.5 13.5 19.5C16.26 19.5 18.5 17.26 18.5 14.5C18.5 11.74 16.26 9.5 13.5 9.5C10.74 9.5 8.5 11.74 8.5 14.5ZM13.5 11.5C15.15 11.5 16.5 12.85 16.5 14.5C16.5 16.15 15.15 17.5 13.5 17.5C11.85 17.5 10.5 16.15 10.5 14.5C10.5 12.85 11.85 11.5 13.5 11.5ZM5.5 6.5H8.5V4.5H5.5V1.5H3.5V4.5H0.5V6.5H3.5V9.5H5.5V6.5Z"
                      fill="white" />
                  </svg>
                </mat-icon>
              </button>

              <!-- Hidden file input -->
              <input #fileInput type="file" accept="image/*;capture=camera" hidden
                (change)="handleImageCapture($event, i)" />
            </div>

          </mat-expansion-panel>
        </ng-container>
      </mat-accordion>
    </form>


    <!-- Action Buttons -->
    @if(allowCapture){
    <div fxLayout="row" fxLayoutAlign="space-between end" fxLayoutGap="8" style="margin-top: 16px;">
      <button type="button" mat-button (click)="closeErrorMessageCancel($event)">Cancel.</button>

      <button mat-flat-button type="submit" style="width: 100%;" (click)="onSubmit()"
        [disabled]="!allowCapture">Verify</button>
    </div>
    }
  </div>



</form>